var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-file-search",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h32v32H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 4v5.3a1.33 1.33 0 0 0 1.33 1.33h5.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28h-6.67a2.67 2.67 0 0 1 -2.67 -2.67v-18a2.67 2.67 0 0 1 2.67 -2.67h9.33l6.67 6.67v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.33 23.33m-3.33 0a3.33 3.33 0 1 0 6.66 0a3.33 3.33 0 1 0 -6.66 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.67 26l3.33 3.33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrip);
export default __webpack_public_path__ + "static/media/grip.1b0fed3ab605349e902beb755d3149dc.svg";
export { ForwardRef as ReactComponent };